// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2tj3D","select":"Header_select__PvPiZ","clinic":"Header_clinic__1JK6V"};